import type { InboxAlertsTranslation } from './en';

/** Arabic (Modern Standard). Pending review by native speakers, as the note in the interface says. */
export const inboxAlertsAr: InboxAlertsTranslation = {
  status: {
    label: 'حالتك',
    online: 'متصل',
    away: 'بعيد',
    offline: 'غير متصل',
    hint: 'يُبلَّغ العملاء بأن شخصًا متصل فقط عندما يكون أحد القادرين على الرد متصلًا.',
    idle: 'يراك فريقك بعيدًا: لم يُستخدم Studio منذ بضع دقائق.',
    changed: 'حالتك الآن: {{status}}.',
    teammate: '{{name}}، {{status}}',
  },
  settings: {
    button: 'التنبيهات',
    title: 'الأصوات وتنبيهات سطح المكتب',
    description: 'هذه الإعدادات خاصة بك وحدك. يحتفظ كل زميل بإعداداته.',
    mute: 'كتم كل الأصوات',
    muteHint: 'تظل تنبيهات سطح المكتب والعدّاد على تبويب المتصفح تعمل.',
    volume: 'مستوى الصوت',
    volumeValue: '{{value}} بالمئة',
    silent: 'لن يُشغَّل أي صوت أثناء كتم الأصوات أو عندما يكون مستوى الصوت صفرًا.',
    events: {
      title: 'الصوت لكل حدث',
      newChat: 'محادثة تنتظر شخصًا، أو تجاوزت وقت الرد',
      customerMessage: 'يكتب عميل في محادثتك، أو في محادثة لم يتسلمها أحد',
      assigned: 'عرض محادثة عليك أو إسنادها إليك أو تحويلها إليك',
    },
    sounds: {
      chime: 'رنين',
      pop: 'فقاعة',
      bell: 'جرس',
      drop: 'قطرة',
      ping: 'نغمة',
      none: 'بلا صوت',
    },
    play: 'تشغيل {{sound}}',
    blocked: 'أبقى المتصفح الصوت صامتًا. انقر في أي مكان بالصفحة مرة واحدة ثم أعد المحاولة.',
    saveFailed: 'تعذّر حفظ آخر تغيير. تعرض الإعدادات ما هو محفوظ.',
    desktop: {
      title: 'تنبيهات سطح المكتب',
      enabled: 'إظهار تنبيه على سطح المكتب عندما يكون Studio في الخلفية',
      enabledHint: 'يصلك تنبيه عن كل محادثة أو رسالة أو إسناد جديد أثناء وجودك في مكان آخر.',
      preview: 'إظهار بداية رسالة العميل',
      previewHint: 'أوقف هذا إذا كان بإمكان آخرين رؤية شاشتك.',
      unsupported: 'لا يستطيع هذا المتصفح إظهار تنبيهات سطح المكتب.',
      prompt: 'سيطلب متصفحك الإذن. اختر «السماح».',
      allow: 'السماح بتنبيهات سطح المكتب',
      granted: 'تنبيهات سطح المكتب مسموح بها في هذا المتصفح.',
      denied:
        'تنبيهات سطح المكتب محظورة في هذا المتصفح. لتفعيلها، اسمح بالإشعارات لهذا الموقع من إعدادات المتصفح، ثم أعد تحميل الصفحة.',
      test: 'إرسال تنبيه تجريبي',
      testTitle: 'تنبيه تجريبي من Hamnivo',
      testBody: 'هكذا يبدو تنبيه سطح المكتب. انقر عليه للعودة إلى Studio.',
    },
  },
  banner: {
    title: 'اعرف بالمحادثات الجديدة حتى عندما يكون Studio في الخلفية',
    description:
      'اسمح بتنبيهات سطح المكتب لتعرف بالمحادثات والرسائل الجديدة أثناء عملك في تبويب أو نافذة أخرى.',
    allow: 'السماح بتنبيهات سطح المكتب',
    later: 'ليس الآن',
  },
  alert: {
    chat_waiting: '{{name}} ينتظر شخصًا',
    sla_overdue: '{{name}} تجاوز هدف وقت الرد',
    sla_overdue_lead: 'لم يرد أحد على {{name}} في الوقت المحدد',
    chat_offered: 'محادثة {{name}} معروضة عليك: اقبلها أو ارفضها',
    customer_message: 'رسالة جديدة من {{name}}',
    assigned: 'أُسندت إليك محادثة',
    assignedBody: '{{name}}: {{preview}}',
    open: 'افتح المحادثة لقراءتها.',
  },
  unread: {
    row: 'رسائل غير مقروءة: {{count}}',
  },
  typing: {
    customer: '{{name}} يكتب…',
  },
  visitor: {
    title: 'زيارة الموقع',
    notNoted: 'لا تسجّل هذه العلامة التجارية الصفحات التي يتصفحها الزوار.',
    none: 'لا توجد صفحات مسجّلة لهذا العميل. ربما يستخدم «عدم التتبع»، أو فُتحت المحادثة في مكان لا يعمل فيه برنامج الدردشة الخاص بالموقع.',
    online: 'على الموقع الآن',
    left: 'غادر الموقع {{when}}',
    currentPage: 'الصفحة الحالية',
    entryPage: 'دخل من',
    visits: 'الزيارات',
    visitor: 'الزائر',
    returning: 'عائد',
    new: 'جديد',
    timeOnSite: 'الوقت على الموقع',
    underMinute: 'أقل من دقيقة',
    country: 'البلد',
    device: 'الجهاز',
    language: 'اللغة',
    cameFrom: 'جاء من',
    pages: 'الصفحات في هذه الزيارة',
    untitled: 'صفحة بلا عنوان',
    openPage: 'فتح {{page}} في تبويب جديد',
    types: { desktop: 'حاسوب', mobile: 'هاتف', tablet: 'جهاز لوحي', other: 'جهاز' },
    privacy: 'تُسجَّل الصفحات دون معاملات الاستعلام وتُحفظ 30 يومًا. لا يُخزَّن عنوان IP.',
  },
  live: {
    link: 'الزوار المباشرون',
    title: 'الزوار المباشرون',
    description: 'الأشخاص الموجودون على مواقعك الآن. تتحدث القائمة كل بضع ثوانٍ.',
    back: 'العودة إلى صندوق الوارد',
    brand: 'العلامة التجارية',
    allBrands: 'كل العلامات التجارية',
    loading: 'جارٍ تحميل الزوار',
    summary: 'على الموقع الآن: {{number}}',
    updated: 'آخر تحديث {{time}}',
    table: 'الزوار الموجودون على الموقع الآن',
    columns: {
      visitor: 'الزائر',
      page: 'الصفحة',
      time: 'الوقت على الموقع',
      country: 'البلد',
      device: 'الجهاز',
      visits: 'الزيارات',
      actions: 'الإجراءات',
    },
    returning: 'عائد · {{number}}',
    new: 'جديد',
    openChat: 'فتح المحادثة',
    openChatFor: 'فتح المحادثة مع {{name}}',
    invite: 'بدء محادثة',
    inviteFor: 'بدء محادثة مع {{name}}',
    empty: {
      title: 'لا أحد على موقعك الآن',
      description:
        'يظهر الزوار هنا ما دامت لديهم صفحة مفتوحة. يتطلب ذلك وجود برنامج الدردشة على موقعك وتفعيل تسجيل الصفحات للعلامة التجارية.',
    },
    forbidden: {
      title: 'الزوار المباشرون غير متاحين لك',
      description: 'دورك لا يشمل قراءة المحادثات.',
    },
    dialog: {
      title: 'بدء محادثة مع {{name}}',
      description:
        'تظهر رسالتك بجانب زر الدردشة في الصفحة التي يتصفحها. إذا فتحها تبدأ المحادثة بكلماتك.',
      message: 'رسالتك',
      hint: 'حتى 300 حرف.',
      default: 'مرحبًا! هل أستطيع مساعدتك في العثور على شيء؟',
      send: 'إرسال الدعوة',
      sent: 'أُرسلت الدعوة. تظهر خلال ثوانٍ وتنتظر 3 دقائق.',
      gone: 'غادر هذا الزائر الموقع.',
    },
    settings: {
      title: 'تسجيل الزوار',
      description: 'اختر ما إذا كانت العلامة التجارية تسجّل الصفحات التي يتصفحها الزوار.',
      brand: 'العلامة التجارية',
      tracking: 'تسجيل الصفحات التي يتصفحها الزوار',
      trackingHint:
        'مفعّل افتراضيًا. يُستثنى دائمًا الزوار الذين يرسل متصفحهم «عدم التتبع» أو «التحكم بالخصوصية العالمي»، وتُخبر الدردشة الزوار بأن الصفحات تُسجَّل.',
      queries: 'الاحتفاظ بالجزء الذي يلي علامة الاستفهام في عنوان الصفحة',
      queriesHint:
        'متوقف افتراضيًا: يُحذف قبل تخزين أي شيء، لأنه قد يحتوي على عناوين بريد إلكتروني أو أرقام طلبات. عند تفعيله تظل القيم التي تشبه كلمات المرور أو الرموز تُحذف.',
      retention: 'تُحذف الصفحات والزيارات بعد 30 يومًا من آخر ظهور للزائر. لا يُخزَّن عنوان IP.',
      save: 'حفظ',
      saved: 'تم الحفظ. يسري من الصفحة التالية التي يفتحها كل زائر.',
    },
  },
  library: {
    link: 'الردود المحفوظة والوسوم',
    title: 'الردود المحفوظة والوسوم',
    description:
      'ردود جاهزة ووسوم يشاركها فريقك. يسري أي تغيير على كل من يردّ على العملاء لهذه العلامة التجارية.',
    back: 'العودة إلى صندوق الوارد',
    brand: 'العلامة التجارية',
    loading: 'جارٍ تحميل الردود المحفوظة والوسوم',
    noBrands: 'لا توجد علامة تجارية بعد. الردود المحفوظة والوسوم تتبع محادثة العلامة التجارية.',
    notSetUp: {
      title: 'لم تُعدّ المحادثة لـ {{name}} بعد',
      description:
        'اربط العلامة التجارية بالمحادثة أولًا. بعد ذلك يمكنك إعداد ردودها المحفوظة ووسومها هنا.',
      action: 'فتح العلامات التجارية والتثبيت',
    },
    forbidden: {
      title: 'الردود المحفوظة والوسوم غير متاحة لك',
      description: 'لا يشمل دورك إدارة صندوق الوارد. اطلب المساعدة من مسؤول.',
    },
    hint: {
      add: 'إضافة وسوم',
      ask: 'اطلب ممن يدير صندوق الوارد إضافتها.',
    },
    replies: {
      title: 'الردود المحفوظة',
      description:
        'يختار فريقك منها بزر «الردود المحفوظة» بجانب مربع الرد. تُملأ تفاصيل مثل اسم العميل من المحادثة.',
      add: 'إضافة رد محفوظ',
      search: 'البحث في الردود المحفوظة',
      noMatch: 'لا يوجد رد محفوظ يطابق بحثك.',
      table: 'الردود المحفوظة لهذه العلامة التجارية',
      columns: { code: 'الرمز المختصر', text: 'النص', actions: 'الإجراءات' },
      edit: 'تعديل',
      editFor: 'تعديل الرد المحفوظ {{code}}',
      delete: 'حذف',
      deleteFor: 'حذف الرد المحفوظ {{code}}',
      empty: {
        title: 'لا توجد ردود محفوظة بعد',
        description: 'أضف الإجابات التي يكتبها فريقك مرارًا، مثل ساعات العمل أو طريقة الإرجاع.',
      },
      added: 'أُضيف الرد المحفوظ {{code}}.',
      saved: 'حُفظ الرد المحفوظ {{code}}.',
      deleted: 'حُذف الرد المحفوظ {{code}}.',
      dialog: {
        addTitle: 'إضافة رد محفوظ',
        editTitle: 'تعديل الرد المحفوظ {{code}}',
        description: 'يستطيع كل من يردّ على العملاء لهذه العلامة التجارية استخدامه فورًا.',
        code: 'الرمز المختصر',
        codeHint:
          'اسم قصير يبحث عنه فريقك، مثل refund-policy. حروف وأرقام و - و _ فقط، دون مسافات.',
        codeRequired: 'أدخل رمزًا مختصرًا.',
        codeInvalid: 'استخدم حروفًا وأرقامًا و - و _ فقط (دون مسافات)، حتى 40 حرفًا.',
        codeTaken: 'يستخدم رد محفوظ آخر هذا الرمز المختصر.',
        text: 'النص',
        textHint: 'حتى {{number}} حرف.',
        textRequired: 'أدخل نص الرد.',
        details: 'أضف تفصيلًا من المحادثة',
        detailsHint: 'يُملأ عند استخدام الرد. إن لم يكن معروفًا يُطلب من الموظف ملؤه يدويًا.',
        detail: {
          firstName: 'الاسم الأول للعميل',
          name: 'الاسم الكامل للعميل',
          agent: 'اسمك',
          brand: 'اسم العلامة التجارية',
        },
        save: 'حفظ',
        add: 'إضافة الرد المحفوظ',
      },
      confirm: {
        title: 'حذف الرد المحفوظ {{code}}؟',
        body: 'يختفي لدى كل أعضاء فريقك. الرسائل التي أُرسلت سابقًا لا تتغير.',
        action: 'حذف الرد المحفوظ',
      },
    },
    tags: {
      title: 'الوسوم',
      description:
        'تسميات يضعها فريقك على المحادثات لترتيبها والعثور عليها. يضيفها الموظفون من لوحة تفاصيل المحادثة.',
      add: 'إضافة وسم',
      table: 'وسوم هذه العلامة التجارية',
      columns: { name: 'الاسم', description: 'الوصف', actions: 'الإجراءات' },
      edit: 'تعديل',
      editFor: 'تعديل الوسم {{name}}',
      delete: 'حذف',
      deleteFor: 'حذف الوسم {{name}}',
      empty: {
        title: 'لا توجد وسوم بعد',
        description: 'أضف وسومًا مثل vip أو refund ليتمكن فريقك من ترتيب المحادثات.',
      },
      added: 'أُضيف الوسم {{name}}.',
      saved: 'حُفظ الوسم {{name}}.',
      deleted: 'حُذف الوسم {{name}}.',
      dialog: {
        addTitle: 'إضافة وسم',
        editTitle: 'تعديل الوسم {{name}}',
        description: 'يستطيع فريقك وضعه على المحادثات فورًا.',
        name: 'الاسم',
        nameHint:
          'حرفان على الأقل من الحروف والأرقام، ويُسمح بـ - و _ بعد الأول، مثل vip أو order-problem. يُحفظ بأحرف صغيرة.',
        nameRequired: 'أدخل اسمًا للوسم.',
        nameInvalid:
          'استخدم من 2 إلى 50 حرفًا أو رقمًا، ويُسمح بـ - و _ بعد الأول ودون مسافات. لا تقبل خدمة المحادثة الحروف المصحوبة بعلامات التشكيل (كما في الهندية): اكتب الاسم بأحرف إنجليزية.',
        nameTaken: 'يوجد وسم بهذا الاسم.',
        renameNote: 'تغيير الاسم يغيّر هذا الوسم في كل محادثة تحمله.',
        descriptionLabel: 'الوصف',
        descriptionHint: 'اختياري. حتى {{number}} حرف.',
        color: 'اللون',
        colorChosen: 'اللون المختار: {{name}}',
        save: 'حفظ',
        add: 'إضافة الوسم',
      },
      colors: {
        blue: 'أزرق',
        green: 'أخضر',
        teal: 'أزرق مخضر',
        orange: 'برتقالي',
        red: 'أحمر',
        pink: 'وردي',
        purple: 'بنفسجي',
        grey: 'رمادي',
        custom: 'مخصص ({{hex}})',
      },
      confirm: {
        title: 'حذف الوسم {{name}}؟',
        body: 'يُزال من القائمة التي يختار منها فريقك ومن كل محادثة تحمله.',
        action: 'حذف الوسم',
      },
    },
  },
};
